<template>
    <v-container fluid>
        <v-tabs
            v-model="step"
            fixed-tabs
            style="background-color: white !important; border-radius: 16px; overflow: hidden"
        >
            <v-tab value="clients" href="#clients"> <strong>Tous les clients</strong></v-tab>
            <v-tab value="dashboard" href="#dashboard"> <strong>Tableau de bord</strong></v-tab>
            <v-tab value="clientBilling" href="#clientBilling"> <strong>Un client</strong></v-tab>
            <v-tab value="priceList" href="#priceList"> <strong>Grille tarifaire</strong></v-tab>
        </v-tabs>
        <v-tabs-window v-model="step">
            <v-window-item value="clients">
                <v-row class="d-flex justify-center" v-if="loading">
                    <v-col>
                        <v-progress-circular
                            :size="70"
                            :width="7"
                            color="primary"
                            indeterminate
                            style="margin: 24px"
                        />
                    </v-col>
                </v-row>
                <v-row v-if="!loading" class="pt-4">
                    <v-spacer />
                    <v-col cols="2" class="d-flex justify-end">
                        <v-btn-icon
                            @click.stop="download"
                            :loading="excelLoading"
                            :disabled="!clients.length"
                            size="small"
                            icon="$fa-cloud-download-alt"
                        />
                    </v-col>
                </v-row>
                <v-row v-if="!loading">
                    <v-col cols="12">
                        <v-data-table
                            :headers="headers"
                            :items="clients"
                            :loading="loading"
                            class="table"
                            fixed-header
                            max-height="60vh"
                        >
                            <template #item="props">
                                <tr>
                                    <td class="text-left">{{ props.item.name }}</td>
                                    <td class="text-left">
                                        {{ formatDate(props.item.createdAt) }}
                                    </td>
                                    <td class="text-left">
                                        {{
                                            props.item.bobbeePriceList
                                                ? props.item.bobbeePriceList.name
                                                : ""
                                        }}
                                    </td>
                                    <td class="text-right">{{ props.item.lastCount }}</td>
                                    <td class="text-right">
                                        {{
                                            newCommonFormatCurrency(props.item.lastPrice, undefined)
                                        }}
                                    </td>
                                    <!-- <td class="text-right"> {{newCommonFormatCurrency(props.item.lastInvoicedPrice, undefined) }}</td> -->
                                    <td class="text-right">
                                        {{
                                            newCommonFormatCurrency(
                                                props.item.totalPrice,
                                                undefined,
                                            )
                                        }}
                                    </td>
                                    <td class="text-right">
                                        {{
                                            newCommonFormatCurrency(
                                                props.item.totalInvoicedPrice,
                                                undefined,
                                            )
                                        }}
                                    </td>
                                    <td class="text-right">
                                        {{ formatPercentage(props.item.variation) }}
                                    </td>
                                    <td class="text-center">
                                        <!-- <v-btn
                                            text
                                            color="primary"
                                            @click.stop="update(props.item)"
                                            :loading="props.item.loading"
                                            v-if="props.item.id !== 'all'"
                                        >
                                            <v-icon  size="small">$fa-chart-line</v-icon>
                                        </v-btn> -->
                                        <v-btn-icon
                                            @click.stop="createInvoices(props.item)"
                                            :loading="props.item.invoiceLoading"
                                            v-if="props.item.id === 'all' || !props.item.grouped"
                                            size="small"
                                            icon="$fa-file-invoice"
                                        >
                                        </v-btn-icon>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-window-item>
            <v-window-item value="dashboard">
                <v-row class="d-flex justify-center" v-if="loading">
                    <v-col>
                        <v-progress-circular
                            :size="70"
                            :width="7"
                            color="primary"
                            indeterminate
                            style="margin: 24px"
                        />
                    </v-col>
                </v-row>
                <v-row v-if="!loading" class="pt-4">
                    <v-col cols="3">
                        <v-select
                            outlined
                            block
                            v-model="displayType"
                            :items="displayTypes"
                            item-value="id"
                            label="Affichage"
                            density="compact"
                            :item-title="(item) => item.name"
                        >
                        </v-select>
                    </v-col>
                    <v-col cols="1"> </v-col>
                    <v-col cols="2">
                        <v-select
                            outlined
                            block
                            v-model="accountingFirmId"
                            :items="clients"
                            item-value="id"
                            label="Cabinets"
                            density="compact"
                            :item-title="(item) => item.name"
                        >
                        </v-select>
                    </v-col>
                    <v-col cols="2">
                        <oss-date-picker
                            v-model="startDate"
                            :hide-details="true"
                            label="Date de début"
                            :mandatory="false"
                            :textFieldReadOnly="false"
                        />
                    </v-col>
                    <v-col cols="2">
                        <oss-date-picker
                            v-model="endDate"
                            :hide-details="true"
                            label="Date de fin"
                            :mandatory="false"
                            :textFieldReadOnly="false"
                        />
                    </v-col>
                    <v-col cols="2" class="d-flex justify-end">
                        <v-btn
                            text
                            color="primary"
                            @click.stop="download"
                            :loading="excelLoading"
                            :disabled="!clients.length"
                            size="small"
                            icon="$fa-cloud-download-alt"
                        >
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <bar-chart
                            v-if="chartData"
                            :data="chartData"
                            :options="options"
                            :height="$vuetify.display.mobile ? 200 : 350"
                        />
                    </v-col>
                </v-row>
            </v-window-item>
            <v-window-item value="clientBilling">
                <MainBilling :clients="clients"> </MainBilling>
            </v-window-item>
            <v-window-item value="priceList">
                <PriceList> </PriceList>
            </v-window-item>
        </v-tabs-window>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";

import { Apollo } from "@/decorators";

import { Bar as BarChart } from "vue-chartjs";
// import { TooltipItem } from 'chart.js';
import { chartColors } from "../../../../../backend/src/common/chart/graphServices";
import {
    mathFix,
    newCommonFormatCurrency,
} from "../../../../../backend/src/common/services/mathServices";
import Excel from "../../../services/excelServices";

import BOBBEE_CLIENTS from "../../../graphql/billing/BobbeeClients.gql";
// import UPDATE_BOBBEE_BILLING from "../../../graphql/billing/UpdateBobbeeBilling.gql"
import UPDATE_BOBBEE_INVOICES from "../../../graphql/billing/UpdateBobbeeInvoices.gql";

import MainBilling from "./MainBilling.vue";
import PriceList from "./PriceList.vue";
import { getDBFormattedDate } from "@/services/dateServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    components: {
        BarChart,
        MainBilling,
        PriceList,
    },
})
export class BobbeeClients extends Vue {
    // accountingFirmIndice = -1
    accountingFirmId = "";

    startDate = moment().add(-11, "months").format();
    endDate = moment().format();

    displayType: string = "count";

    step = "clients";

    get headers() {
        const headers = [
            { title: "Nom de la société", value: "name", align: "left", sortable: true },
            { title: "Date de création", value: "createdAt", align: "left", sortable: true },
            { title: "Tarif", value: "bobbeePriceList", align: "left", sortable: true },
        ];
        headers.push({
            title: "Nombre de dossiers",
            value: "lastCount",
            align: "right",
            sortable: true,
        });
        headers.push({
            title: "CA du dernier mois",
            value: "lastPrice",
            align: "right",
            sortable: true,
        });
        headers.push({
            title: "CA sur la période",
            value: "totalPrice",
            align: "right",
            sortable: true,
        });
        headers.push({
            title: "CA facturé sur la période",
            value: "totalInvoicedPrice",
            align: "right",
            sortable: true,
        });
        headers.push({ title: "Variation CA", value: "variation", align: "right", sortable: true });
        // }
        headers.push({
            title: "Actions",
            value: this.displayType,
            align: "center",
            sortable: true,
        });
        return headers;
    }

    displayTypes = [
        { id: "count", name: "Nombre de dossiers" },
        // {id: "lastPrice", name:"Chiffre d'affaire estimé du dernier mois"},
        { id: "price", name: "Chiffre d'affaire estimé" },
        { id: "invoicedPrice", name: "Chiffre d'affaire facturé" },
        { id: "priceInvoicedPrice", name: "Chiffre d'affaire estimé et facturé" },
    ];

    formatDate(date) {
        if (!date) return "-";
        return moment(date).format("DD/MM/YYYY");
    }

    get loading() {
        if (this.$apollo.queries.clients) {
            return this.$apollo.queries.clients.loading;
        }
        return false;
    }

    get accountingFirmIndice() {
        return this.clients.findIndex((c) => c.id === this.accountingFirmId);
    }

    newCommonFormatCurrency(value, option = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    formatPercentage(percentage) {
        if (percentage) {
            return mathFix(100 * percentage).toString() + "%";
        }
        return "-";
    }

    @Apollo({
        query: BOBBEE_CLIENTS,
        variables() {
            return {
                startDate: getDBFormattedDate(this.startDate),
                endDate: getDBFormattedDate(this.endDate),
            };
        },
        skip() {
            return (
                !moment(this.startDate).isValid() ||
                !moment(this.endDate).isValid() ||
                moment(this.startDate).isAfter(moment(this.endDate))
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    this.clients = data.getBobbeeClients.clients;
                    if (this.clients.length) {
                        if (this.accountingFirmId) {
                            if (!this.clients.find((c) => c.id === this.accountingFirmId)) {
                                this.accountingFirmId = "";
                            }
                        } else {
                            this.accountingFirmId = this.clients[0].id;
                        }
                    } else {
                        this.accountingFirmId = "";
                        this.clients = [];
                    }
                } else {
                    this.accountingFirmId = "";
                    this.clients = [];
                }
            }
        },
    })
    clients = [];

    @Watch("displayType")
    @Watch("accountingFirmIndice")
    onChartInputChanged() {
        this.changed = true;
        setTimeout(() => (this.changed = false), 100);
    }

    changed: boolean = false;

    get chartData() {
        if (this.changed) return null;
        return this.chartData_;
    }

    get chartData_() {
        if (this.accountingFirmIndice >= 0 && this.accountingFirmIndice < this.clients.length) {
            const client = this.clients[this.accountingFirmIndice];
            const results = client.results;
            let datasets = [];
            if (this.displayType === "priceInvoicedPrice") {
                let data = results.map((r) => r.price);
                datasets.push({
                    label: client.name + " - Prix estimé",
                    data,
                });
                data = results.map((r) => r.invoicedPrice);
                datasets.push({
                    label: client.name + " - Prix facturé",
                    data,
                });
            } else {
                const data =
                    this.displayType === "count"
                        ? results.map((r) => r.count)
                        : this.displayType === "price"
                          ? results.map((r) => r.price)
                          : results.map((r) => r.invoicedPrice);
                datasets.push({
                    label: client.name,
                    data,
                });
            }

            chartColors("bar", datasets, "cool");
            const chartData = {
                labels: results.map((r) => moment(r.date).format("MM/YYYY")),
                datasets: datasets,
            };
            return chartData;
        }
        return null;
    }

    get options() {
        return {
            responsive: true,
            plugins: {
                legend: {
                    display: true,
                    position: "bottom",
                },
            },
            scales: {
                y: {
                    // stacked: true,
                    // min:0,
                    beginAtZero: true,
                    // stepSize: 1
                },
                x: {
                    // stacked: true,
                    // min:0,
                    beginAtZero: true,
                },
            },
            maintainAspectRatio: false,
        };
    }

    excelLoading: boolean = false;

    async download() {
        this.excelLoading = true;

        const excel = new Excel();

        const workbook = excel.createWorkbook();

        const style = excel.getStyle();
        this.exportExcelInNewSheet(excel, workbook, style, "Nombre de dossiers", "count");
        this.exportExcelInNewSheet(excel, workbook, style, "CA estimé", "price");
        this.exportExcelInNewSheet(excel, workbook, style, "CA facturé", "invoicedPrice");

        await excel.export(workbook, "'Clients bobbee");

        this.excelLoading = false;
    }

    exportExcelInNewSheet(excel: Excel, workbook, style, title, displayType) {
        const worksheet = workbook.addWorksheet(title, { views: [{ showGridLines: false }] });
        const firstCol = worksheet.getColumn(1);
        firstCol.width = 30;

        const firstClient = this.clients[0];

        const results = firstClient.results;

        for (let ci = 2; ci <= results.length; ci++) {
            const col = worksheet.getColumn(ci);
            col.width = 15;
        }
        const execelHeaders = results.map((r) => moment(r.date).format("DD/MM/YYYY"));
        execelHeaders.splice(0, 0, "createdAt");
        execelHeaders.splice(0, 0, "Cible");
        execelHeaders.splice(0, 0, "Siret");
        execelHeaders.splice(0, 0, "Cabinet");
        worksheet.addRow(execelHeaders);
        excel.applyProperties(worksheet.lastRow, style.titleFont, style.fill, style.height);

        for (const client of this.clients) {
            if (!client.siret) {
                continue;
            }
            const results = client.results;
            const excelRow =
                displayType === "count" ? results.map((r) => r.count) : results.map((r) => r.price);
            excelRow.splice(0, 0, moment(client.createdAt).format("DD/MM/YYYY"));
            excelRow.splice(0, 0, client.accountingFirm ? "EC" : "SMB");
            excelRow.splice(0, 0, client.siret);
            excelRow.splice(0, 0, client.name);

            worksheet.addRow(excelRow);
            excel.applyProperties(worksheet.lastRow, style.normalFont, undefined, style.height);
        }
    }

    // async update(client) {
    //     client.loading = true
    //     await this.$apollo.mutate({
    //         mutation: UPDATE_BOBBEE_BILLING,
    //         variables: {
    //             id: client.id
    //         }
    //     })
    //     client.loading = false
    // }

    async createInvoices(client) {
        client.invoiceLoading = true;
        await this.$apollo.mutate({
            mutation: UPDATE_BOBBEE_INVOICES,
            variables: {
                id: client.id === "all" ? undefined : client.id,
            },
        });
        client.invoiceLoading = false;
    }
}

export default toNative(BobbeeClients);
</script>

<style lang="scss" scoped></style>
